<div class="label">
    <div class="label-title" id="breadcrumb-label">
        {{title | translate}}
    </div>
</div>
<div class="action" *ngIf="showClose" (click)="remove()">
    <div class="action-media">
        <fui-icon [height]="16" [icon]="'close-badge'" [width]="16"></fui-icon>
    </div>
</div>
